var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#FFFFFF", "padding-top": "15px" } },
    [
      _c("div", { staticClass: "new_user_top2" }, [
        _c("div", { staticClass: "nut2_left" }, [
          _c("div", { staticClass: "nut2l_tx" }, [
            _c("img", { attrs: { src: _vm.userInfo.imageUrl } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nut2l_info" },
            [
              _c("p", [_vm._v(_vm._s(_vm.userInfo.realName))]),
              _vm._v(" "),
              _c("p", { attrs: { title: _vm.userInfo.company.companyName } }, [
                _vm._v(_vm._s(_vm.userInfo.company.companyName))
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { path: "/EditUser", query: { baseVisible: true } }
                      }
                    },
                    [_vm._v("账号设置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:" },
                      on: { click: _vm.myCorrection }
                    },
                    [_vm._v("我的纠错")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.myCorrectionVisible,
                    title: "我的纠错",
                    width: "90%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.myCorrectionVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.myCorrectionData } },
                    [
                      _c("el-table-column", {
                        attrs: { label: "题干" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(scope.row.content)
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "纠错时间",
                          property: "ctime",
                          width: "200"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "处理反馈", property: "correctMsg" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nut2_right" }, [
          _c(
            "div",
            { staticClass: "nut2r" },
            [
              _c("el-tooltip", { attrs: { content: " 此功能暂未开通 " } }, [
                _c(
                  "a",
                  {
                    staticClass: "nut2r_wdlx",
                    staticStyle: { color: "#FFFFFF" },
                    attrs: { href: "javascript:" },
                    on: { click: _vm.notice }
                  },
                  [_vm._v(" 我的练习 ")]
                )
              ]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { content: " 此功能暂未开通 " } }, [
                _c(
                  "a",
                  {
                    staticClass: "nut2r_wdks",
                    staticStyle: { color: "#FFFFFF" },
                    attrs: { href: "javascript:" },
                    on: { click: _vm.notice }
                  },
                  [_vm._v(" 我的考试 ")]
                )
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nut2r_wdxf",
                  staticStyle: { color: "#FFFFFF" },
                  attrs: { to: "/MyScore" }
                },
                [_vm._v("我的学分")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nut2r_pxjl",
                  staticStyle: { color: "#FFFFFF" },
                  attrs: { to: "/MyTraining" }
                },
                [_vm._v("培训记录")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nut2r_bkjl",
                  staticStyle: { color: "#FFFFFF" },
                  attrs: { to: "/MyCard" }
                },
                [_vm._v("绑卡记录")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.trainingList && _vm.trainingList.length == 0
        ? _c("div", { staticClass: "new_user_project_noSource" }, [
            _vm._v(
              "暂无推荐项目，请确认个人信息的准确性，以便及时获取推荐项目；"
            ),
            _c("br"),
            _vm._v("若有疑问请拨打客服电话："),
            _c("span", [_vm._v("400-822-2055")])
          ])
        : _c(
            "div",
            { staticClass: "new_user_project" },
            [
              _c("div", { staticClass: "nup_top" }, [
                _c("div", { staticClass: "nupt_title" }, [_vm._v("我的课程")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nupt_main" },
                  _vm._l(_vm.trainingList, function(item, index) {
                    return _c(
                      "a",
                      {
                        key: index,
                        class: {
                          nupt_main_sel: _vm.currentTraining.id === item.id
                        },
                        attrs: { title: item.name, href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.switchTraining(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _vm.currentTraining && _vm.currentTraining.businessType == 102
                ? _c("cme-page", {
                    attrs: { currentTraining: _vm.currentTraining }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTraining && _vm.currentTraining.businessType != 102
                ? _c("not-cme-page", {
                    attrs: { currentTraining: _vm.currentTraining }
                  })
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      _c("learnCardBind", {
        attrs: { value: _vm.showLearnCardBind },
        on: {
          "update:value": function($event) {
            _vm.showLearnCardBind = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "text-align": "center" },
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.examVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.examVisible = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
            [
              _vm._v(
                "您有一场需在开始课程学习前进行的考试，请确认是否开始考试？"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "40px" },
              attrs: { type: "primary" },
              on: { click: _vm.openExamPage }
            },
            [_vm._v("开始考试")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              nativeOn: {
                click: function($event) {
                  _vm.examVisible = false
                }
              }
            },
            [_vm._v("忽略考试")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("verifiModal", {
        attrs: {
          usermobile: _vm.userInfo.mobile,
          verifiModalVisible: _vm.verifiModalVisible
        },
        on: {
          "update:verifiModalVisible": function($event) {
            _vm.verifiModalVisible = $event
          },
          "update:verifi-modal-visible": function($event) {
            _vm.verifiModalVisible = $event
          }
        }
      }),
      _vm._v(" "),
      _c("ChangePassword", {
        model: {
          value: _vm.changePasswordShow,
          callback: function($$v) {
            _vm.changePasswordShow = $$v
          },
          expression: "changePasswordShow"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-337fe746", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337fe746","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/Index.vue
// module id = null
// module chunks = 